import { Directive, HostBinding, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[tagErrorState]'
})
export class TagErrorStateDirective {
  @Input('tagErrorState') control: AbstractControl

  @HostBinding('class.interval-tag-required')
  get intervalRequiredClass() {
    if (!this.control) return false
    const ctlr = this.control
    return !(ctlr.touched && ctlr.invalid) && (ctlr.hasError('required') || ctlr.hasError('tagRequired'))
  }

  @HostBinding('class.interval-tag-error')
  get intervalErrorClass() {
    if (!this.control) return false
    const ctlr = this.control
    return ctlr.touched && (ctlr.hasError('required') || ctlr.hasError('tagRequired'))
  }

  @HostBinding('hidden')
  get hidden() {
    if (!this.control) return false
    const ctlr = this.control
    if (!ctlr.hasError('required') && !ctlr.hasError('tagRequired')) return true
    return ctlr.value !== null && ctlr.value !== '' && ctlr.value !== undefined
  }
}